/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import {
    CContainer, CBreadcrumb, CBreadcrumbItem,
    CCard, CCardHeader, CCardBody, CRow, CCol, CSpinner
} from '@coreui/react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';
import SampleInputs from '../../components/SampleInputs/SampleInputs';
import { getSample, getSampleDropdown } from '../../services/endpoints';
import { updateSampleRequest } from '../../store/sample/sampleActions';

const UpdateSample = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();
    const { t } = useTranslation();

    const isLoading = useSelector(state => state.sampleReducer.isLoading);
    const [dataLoading, setDataLoading] = useState(true);
    const [error, setError] = useState(null);
    const [initialData, setInitialData] = useState(null);

    const [compositionOptions, setCompositionOptions] = useState([]);
    const [weaveTypeOptions, setWeaveTypeOptions] = useState([]);
    const [currencyOptions, setCurrencyOptions] = useState([]);
    const [dropdownLoading, setDropdownLoading] = useState(true);
    const [dropdownError] = useState(null);

    const refreshDropdownOptions = async (filters = {}) => {
        const sessionUserId = localStorage.getItem('sessionUserId');
        const dropdownResponse = await getSampleDropdown({ SessionUserId: sessionUserId, ...filters });
        const data = dropdownResponse?.data || {};

        if (!filters.WeaveTypeSearchTerm && data.Compositions) {
            setCompositionOptions(data.Compositions);
        }
        if (!filters.CompositionSearchTerm && data.WeaveTypes) {
            setWeaveTypeOptions(data.WeaveTypes);
        }
        if (data.Currencies) {
            setCurrencyOptions(data.Currencies);
        }

        return data;
    };

    useEffect(() => {
        const fetchData = async () => {
            setDataLoading(true);
            try {
                const sessionUserId = localStorage.getItem('sessionUserId');

                await refreshDropdownOptions();
                setDropdownLoading(false);

                const response = await getSample({ SessionUserId: sessionUserId, SampleId: id });
                if (response?.data?.Result?.ErrorCode === 0) {
                    const samples = response.data.SampleList || [];
                    const targetId = String(id);
                    const sample = samples.find(s => [s.SampleId, s.SampleGuid, s.PrdSampleGuid]
                        .some(value => value != null && String(value) === targetId));

                    if (sample) {
                        setInitialData({
                            ...sample,
                            PrdSampleGuid: sample.PrdSampleGuid || sample.SampleGuid || sample.SampleId || id
                        });
                    } else {
                        setError('Analiz bulunamadi');
                    }
                } else {
                    setError(response?.data?.Result?.ErrorDescription || 'Veri yuklenemedi');
                }
            } catch (err) {
                setError('Veri yuklenirken hata olustu');
                console.error('Load error:', err);
            } finally {
                setDataLoading(false);
            }
        };

        fetchData();
    }, [id]);

    const handleSubmit = (data) => {
        const sessionUserId = localStorage.getItem('sessionUserId');

        const samplePayload = {
            SessionUserId: sessionUserId,
            SampleId: id,
            CardNo: data.CardNo || '',
            CompanyName: data.CompanyName || '',
            Note: data.Note || '',
            Certificate: data.Certificate || '',
            FabricWidth: data.FabricWidth || '',
            FabricWeight: data.FabricWeight || '',
            ReedWidth: data.ReedWidth || '',
            Price: data.Price || '',
            Datetime: data.Datetime || '',
            CompositionGuid: data.CompositionGuid || '',
            WeaveTypeGuid: data.WeaveTypeGuid || '',
            CurrencyGuid: data.CurrencyGuid || '',
            Photo: data.Photo || '',
            TotalThread: data.TotalThread || '',
            ReedNo: data.ReedNo || '',
            Dgts: data.Dgts || '',
            WarpDensity: data.WarpDensity || '',
            WeftDensity: data.WeftDensity || '',
            GrayWarp: data.GrayWarp || '',
            GrayWeft: data.GrayWeft || ''
        };

        dispatch(updateSampleRequest({
            sampleData: samplePayload,
            tableData: data.allTableData || [],
            sampleFactorRowsByThreadType: data.sampleFactorRowsByThreadType || { 1: [], 2: [] },
            navigate,
            sessionUserId
        }));
    };

    const handleCancel = () => {
        navigate('/samples');
    };

    if (dataLoading) {
        return (
            <CContainer className="text-center py-5">
                <CSpinner color="primary" />
                <p className="mt-2">{t('loading')}</p>
            </CContainer>
        );
    }

    return (
        <CContainer>
            <CBreadcrumb className="mb-4">
                <CBreadcrumbItem
                    href="#/samples"
                    onClick={e => { e.preventDefault(); handleCancel(); }}
                >
                    {t('samples')}
                </CBreadcrumbItem>
                <CBreadcrumbItem active>{t('updateSample')}</CBreadcrumbItem>
            </CBreadcrumb>
            <CRow>
                <CCol xs={12}>
                    <CCard>
                        <CCardHeader><h4>{t('updateSample')}</h4></CCardHeader>
                        <CCardBody>
                            <SampleInputs
                                onSubmit={handleSubmit}
                                onCancel={handleCancel}
                                isLoading={isLoading}
                                error={error}
                                initialData={initialData}
                                compositionOptions={compositionOptions}
                                weaveTypeOptions={weaveTypeOptions}
                                currencyOptions={currencyOptions}
                                dropdownLoading={dropdownLoading}
                                dropdownError={dropdownError}
                                onDropdownRefresh={refreshDropdownOptions}
                                isEditMode
                            />
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
        </CContainer>
    );
};

export default UpdateSample;
